import * as React from "react";
export class FreeHtml extends React.Component {
    renderHtml() {
        return {
            __html: this.props.html
        };
    }
    render() {
        return (React.createElement("div", { dangerouslySetInnerHTML: this.renderHtml(), className: "rj-free-html" }));
    }
}
//# sourceMappingURL=FreeHtml.js.map